import { PrintMap } from "@esdm/map/dist/map/tools/PrintMap";
import { IPrintOptions } from "@esdm/map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "@esdm/map/dist/map/tools/DownloadMapPng";
import { IMapViewStore } from "@esdm/map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "@esdm/map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "@esdm/map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "@esdm/map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "@esdm/map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "@esdm/map/dist/map/store/MapViewStore";
import { MapContextMenu } from "@esdm/map/dist/map/tools/MapContextMenu";
import { ToolTipProvider } from "@esdm/map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "@esdm/map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "@esdm/map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "@esdm/map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "@esdm/map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { FeatureAdd } from "@esdm/map/dist/layers/vector/sources/loaders/FeatureAdd";
import { ExtentsNavigation } from "@esdm/map/dist/map/controls/ExtentsNavigation";
import { LayerGroupFactory } from "@esdm/map/dist/layers/groups/LayerGroupFactory";
import { LayerGroupCollection } from "@esdm/map/dist/layers/groups/LayerGroupCollection";
import { MapFilters } from "@esdm/map/dist/map/filters/MapFilters";
import { GridRef } from "@esdm/map/dist/map/controls/GridRef";
import { MapPopup, MapPopupOptions } from "@esdm/map/dist/map/MapPopup";
import { IMappingTextPack } from "@esdm/map/dist/resources/MappingTextPack";
import { MousePosition } from "@esdm/map/dist/map/controls/MousePosition";
import { GeoNames } from "@esdm/map/dist/gazetteer/geonames";
import { IStyleFactory } from "@esdm/map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "@esdm/map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "@esdm/map/dist/layers/vector/sources";
import { IBaseLayerFactory } from "@esdm/map/dist/baselayers/interfaces/IBaseLayerFactory";
import { IVectorLayerGroup } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroup";
import { ZoomToDataBounds } from "@esdm/map/dist/layers/vector/ZoomToDataBounds";
import { VectorLayerStrategy } from "@esdm/map/dist/layers/vector/VectorLayerStrategy";
import { WfsParamSourceMapServer } from "@esdm/map/dist/layers/vector/sources/wfs";

import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapFactory,
    BaseLayerFactory_3857,
    MapFactory,
    Logger,
    BaseLayerType,
    MiniMapsForLists
} from "@esdm/map";

import { ColchesterHerBoundary } from "./ColchesterHerBoundary";
import { HbsmrStyleFactory } from "./HbsmrStyleFactory";
import { HbsmrResourcefactory } from "./HbsmrResourceFactory";
import { ColchesterRecordType, ColchesterRecordSubType } from "./ColchesterRecordTypes";
import { DefaultLayerConfigurationFactory } from "./DefaultLayerConfigurationFactory";
import { DefaultMapOptions } from "./DefaultMapOptions";
import { TextPackLoader, TextPacks } from "./TextPackLoader";
import { MapBase } from "./MapBase";
import { HbsmrIdentity, HbsmrUser } from "./HbsmrUser";
import { LayerGroupCollections } from "@esdm/map/dist/layers/groups/LayerGroupCollections";
import { IlayerGroupCollectionConfig } from "@esdm/map/dist/layers/groups/IlayerGroupCollectionConfig";
import { debounce } from "debounce"
import { CustomClient_BaseLayerFactory_3857 } from "./customTypings/CustomClient_BaseLayerFactory_3857";

import "../wwwroot/css/ol.css";
import "../wwwroot/css/bootstrap-select.css"
import "../wwwroot/css/ol-contextmenu.css";

$(function () { 
    let didLoadMap = false;

    let ele = $("#theMap"); 
    let maxFeatureCount: number = <number>ele.data("max-feature-count");

    let data = $("#searchMapData");
    let searchString: string = <string>data.data("search-string");
    let searchMode: string = <string>data.data("search-mode");
 
    let printOptions: PrintMap =  new PrintMap();

    if (!printOptions.isPrintMap) {
        resizeMap();
        window.addEventListener('resize', debounce(resizeMap, 250));  
    } 

    let loadMap = function () {
        HbsmrIdentity.fetch().then(function (e) {
            let user = e;
            let init = function (textpacks: TextPacks) {
                let map = new SearchMap("theMap", searchString, searchMode, maxFeatureCount, printOptions, textpacks.mapping, user);
                didLoadMap = true;
            }
            TextPackLoader.load().then(init);
        });
    }

    function resizeMap() {
        var height = $(window).height() - $("#mapContainer").offset().top;
        if (height <= 500) {
            height = 500;
        }
        $('#mapContainer').height(height);
    };

    //function resizeMap() {
    //    //use max footer height, especially on mobile
    //    var fHeight = $("footer").height();
    //    fHeight = Math.min(fHeight, 200);

    //    var height = $(window).height() - $("#mapContainer").offset().top - fHeight - 18;
    //    if (height <= 400) {
    //        height = 400;
    //    }
    //    $('#mapContainer').height(height);
    //};

    if (printOptions.isPrintMap) {       
        loadMap();
    }
    else {
        let bingAPIKey: string = ele.data("bing-api-key");
        let esdmOsmApiKey: string = ele.data("esdm-osm-api-key");   
        let baseLayerFactory: IBaseLayerFactory = new BaseLayerFactory_3857();        
        let miniMaps = new MiniMapsForLists(BaseLayerType.BingOS, bingAPIKey, esdmOsmApiKey, baseLayerFactory, "EPSG:27700", "EPSG:3857");
               
        //only show the map when the map tab is visible
        $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
            let target = $(e.target).attr("href") // activated tab
            if (target === "#tabMap") {
                if (didLoadMap === false) {
                    resizeMap();
                    loadMap();
                }
            } else if (target === "#tabList" && didLoadMap === true) {
                // If the map has loaded it means the user has visited the 'Map' tab, they could have possibly also put the map into fullscreen mode
                // if they have then we need to redraw/refresh the miniMaps on the search results list, as they don't refresh correctly after exiting
                // the fullscreen mode
                miniMaps.refreshMiniMaps();
            }
        });
    }
});

export class SearchMap extends MapBase {

    private map: IMap;
    private mfOptions: MapOptions;
    private mapStore: IMapViewStore;
    private styleFactory: IStyleFactory;
    private ls: MapLayerSwitcher;
    private vectorLayerGroups: Array<IVectorLayerGroup>;
    private infoPopup: MapPopup;
    private initialised = false;
    private herMask: IMapAreaMask;
    private geoNames: GeoNames;
    private logger: ILogger;
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;
    private downloadPng: DownloadMapPng;
    private extentsNavigation: ExtentsNavigation;
    private gridRefFinder: GridRef;
    private mousePosition: MousePosition;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private layerGroups: LayerGroupCollections;
    private layerGroupFactory: LayerGroupFactory;

    constructor(
        private _mapElementId: string,     
        private _searchString: string,
        private _searchMode: string,
        private _maxFeatureCount: number,
        public printOptions: IPrintOptions,
        public mappingTextPack: IMappingTextPack,
        user: HbsmrUser) {
        super(mappingTextPack, user);
        this.init();
    }

    private init = () => {
        if (this.initialised) {
            return;
        }
                
        this.layerConfigFactory = new DefaultLayerConfigurationFactory();
        this.vectorLayerGroupFactory = new VectorLayerGroupFactory();
        this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, null);
        this.mapFilter = new MapFilters();
        this.mapFilter.OgcFilter = new OgcMapFilter();
        this.baseLayerFactory = new CustomClient_BaseLayerFactory_3857();
        this.featureLoader = new GeoJsonFeatureLoader();
        this.featureAdd = new FeatureAdd();
        this.mapFactory = new MapFactory();
        this.logger = new Logger();
        this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);
        this.styleFactory = new HbsmrStyleFactory();
        this.resourcefactory = new HbsmrResourcefactory(this.mappingTextPack);

        this.mfOptions = DefaultMapOptions.GetDefaultOptions(this._mapElementId, "SearchMap");
        this.mfOptions.enableBoundsTracking = false;
        //zoom & centre determines the start position of the map
        this.mfOptions.mapZoom = 11;
        this.mfOptions.mapCentre = [99473, 6779725];  
            
        this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
        this.mfOptions.layerGroupCollection = this.layerGroups;

        this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey);
        //clear the store so we don't remember the layers etc?
        this.mapStore.clear();
       
        this.mapContextMenu = new MapContextMenu(this.mappingTextPack);
        this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
        this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);

        this.herMask = new ColchesterHerBoundary();
        this.map.olMap.addLayer(this.herMask.getMask());

        this.infoPopup = new MapPopup(this.map, this.resourcefactory.getRecordTypeResource(), new ToolTipProvider(), new MapPopupOptions(1));
        this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack, null, {
            showList: false,
            showOpenPanelByDefault: !this.printOptions.isPrintMap,
            rememberActivePanel: true
        });
        this.geoNames = new GeoNames(this.map, this.mappingTextPack);

        if (this.printOptions.isPrintMap) {
            this.printOptions.setMap(this.map);
        }
        this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);
        this.gridRefFinder = new GridRef(this.map, this.mappingTextPack, this.logger);
        this.extentsNavigation = new ExtentsNavigation(this.map, this.logger, this.mappingTextPack);
        this.mousePosition = new MousePosition(this.map, this.mappingTextPack);
        this.initialised = true;
    }

    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {
        let self = this;
        let layerGroupConfig: Array<IVectorLayerGroupConfig> = [
            {
                type: ColchesterRecordType.Monument,
                displayName: 'Monuments <i class="fas fa-filter"></i>',
                strategy: VectorLayerStrategy.All,
                url: "/api/MapServer/Hbsmr",
                wfsParams: new WfsParamSourceMapServer(null, { srsName: "EPSG:27700" }),
                legend: { point: false, line: false },
                zoomToDataBounds: ZoomToDataBounds.Always,
                maxFeatureCount: this._maxFeatureCount,
                urlParams: {
                    searchstring: this._searchString,
                    searchmode: this._searchMode
                },
                layers: [
                    {
                        layerName: "MonumentLinesWFS_Search",
                        minZoom: 11,
                        maxZoom: 19
                    },
                    {
                        layerName: "MonumentPolygonsWFS_Search",
                        minZoom: 11,
                        maxZoom: 19
                    },
                    {
                        layerName: "MonumentPointsWFS_Search",
                        minZoom: 1,
                        maxZoom: 19
                    },
                    {
                        layerName: "MonumentLinesAsPointsWFS_Search",
                        minZoom: 1,
                        maxZoom: 10
                    },
                    {
                        layerName: "MonumentPolygonsAsPointsWFS_Search",
                        minZoom: 1,
                        maxZoom: 10
                    }
                ]
            },
            self.layerConfigFactory.layerConfig(ColchesterRecordType.Event),
            self.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.ScheduledMonument),
            self.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.ListedBuilding),
            self.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.ConservationArea),
            self.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.RegisteredParksAndGardens),
            self.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.LocalList)
        ];

        return [
            {
                ref: "all_layers",
                name: "All layers",
                useAccordion: false,
                expandedOnFirstLoad: true,
                layerGroupConfigs: this.filterMapLayers(layerGroupConfig)
            }
        ];
    }       

}